import { ColorString, FlightImpactDto, FuelDto, PlannedRouteType } from '@fe/core';
import { Position } from '../geodesy/geodesy-types';
import { ChartProps } from './chart/chart-props';

export type LngLatArray = [number, number];
export enum RouteAltitudeSource {
    waypoints,
    cruisingAltitude,
    default
}

export enum RouteProjectionMode {
    distanceToOrigin,
    distanceAlongRoute
}

export enum FuelWeightUnits {
    pound,
    kilogram
}

export enum FuelVolumeUnits {
    gallon,
    liter
}

export interface FuelFormatter {
    formatFuel(fuel: FuelDto | null | undefined, dontShowUnit?: boolean): string;
}

export interface ProfileProps {
    chart: ChartProps;
    horizontalProjection: RouteProjectionMode;
    plannedRouteType: PlannedRouteType;
    fuel: {
        weightUnit: FuelWeightUnits;
        volumeUnit: FuelVolumeUnits;
        formatter: FuelFormatter;
    };
    dayNight: {
        color?: ColorString;
        shade: boolean;
        line: boolean;
    };
    drawImpacts: boolean;
    drawTerrain: boolean;
    drawEtops: boolean;
    routeFlown: {
        drawPoints: boolean;
        drawProjected: boolean;
        colors: ProfileFlownPointsColors;
    };
    barbs: {
        visible: boolean;
        size: [number, number];
        spacing: [number, number];
    };
    heatmap: {
        opacity: number;
        interpolate: boolean;
        type: 'temperature' | 'winds' | null
    };
}

export type ChartCreateOptions = {
    containerId: string;
};

export type TerrainPoint = { position: Position; altitude: number };
export type DistanceElement<T> = [number, T];

export type MousePoint = { x: number; y: number };

export type ProfileFlownPointsColors = {
    defaultColor: string;
    projectedColor: string;
    acarsColor: string;
    adsbTerrestrialColor: string;
    adsbSatelliteColor: string;
    faaAnspColor: string;
};

export type HoverItem = { type: 'impact'; impact: FlightImpactDto };
